import React from 'react';
import { APIAction } from '../../../order-menu/api-action/api-action';
import ActionCard from '../../cards/actionCard/actionCard';
import { useTranslation } from 'react-i18next';
import TransferModal from '../../misc/transfer-modal/transferModal';
import './actionsBlock.css';

export default function ActionsBlock({config, onSubmit = () => {}}) {

    const [showRefuseModal, setShowRefuseModal] = React.useState(false);

    const { t } = useTranslation();
    const {title, subtitle, actions} = config?.actions_block || {};

    const actionMapping = React.useMemo(() => ({
        ValidateTicketTransferStep: { icon: 'check' },
        RefuseTicketTransferStep: { icon: 'redCross' },
    }), [t]);

    const handleActionClick = (actionType) => {
        onSubmit({ data: { action: actionType } });
    };

    const refuseTicketAction = React.useMemo(() => {
        return actions.find(action => action.type === 'RefuseTicketTransferStep');
    }, [actions]);

    return (
        <>
            {showRefuseModal && (
                <TransferModal 
                    open={showRefuseModal} 
                    title={refuseTicketAction.metadata?.modal.title} 
                    body={refuseTicketAction.metadata?.modal.body} 
                    ctaLabel={t('widget.resale.breakdown.cta-confirm')} 
                    onClose={() => setShowRefuseModal(false)} 
                    onClick={() => handleActionClick('RefuseTicketTransferStep')}
                />
            )}
            <div className='neo-actions-block-container'>
                {title && <h3 className='neo-actions-block-title'>{title}</h3>}
                {subtitle && <p className='neo-actions-block-subtitle'>{subtitle}</p>}
                <div className='neo-actions-block-actions'>
                    {actions?.map((action, index) => {
                        const { icon } = actionMapping[action.type] || {};
                        const label = action.label || '';

                        return (
                            <APIAction key={index} name={action.type} actions={actions}>
                                <ActionCard
                                    {...action}
                                    noIconBorder
                                    icon={icon}
                                    label={label}
                                    size='huge'
                                    disabled={!action.enabled}
                                    onClick={() => 
                                        action.type === 'RefuseTicketTransferStep'
                                            ? setShowRefuseModal(true)
                                            : handleActionClick(action.type)
                                    }
                                />
                            </APIAction>
                        );
                    })}
                </div>
            </div>
        </>
    );
}